<div class="full-page-container">
  <fgb-banner [title]="name$ | async"></fgb-banner>

  <div class="d-block d-lg-none">
    <fgb-page-header
      [pageTitle]="'account.page.title'"
      [backButtonLink]="'/'"
      [showQr]="!isSuiteOrPts"
      [showBalance]="!isSuiteOrPts"
    ></fgb-page-header>
  </div>

  <ng-container *notInPopulation="[populations.Pts]">
    <fgb-account-nav></fgb-account-nav>
  </ng-container>

  <div class="container mt-3 mt-lg-4 account-container">
    <ng-container *ifScreenSize="screenType.Desktop">
      <div class="account-item">
        <h5 class="text-start mb-3 mt-lg-0 font-size-25">{{ 'account.member.card.title' | translate }}</h5>
        <fgb-member-card [showSeating]="true"></fgb-member-card></div
    ></ng-container>

    <div class="account-item">
      <h5 class="text-start my-3 mt-0 mb-3 mt-lg-0 font-size-25">{{ 'account.details.title' | translate }}</h5>
      <fgb-account-details></fgb-account-details>

      <ng-container *notInPopulation="[populations.Suite, populations.Pts]">
        <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.edit.questions'">
          <ng-container *ngIf="hasQuestions$ | async">
            <div style="padding-top: 20px">
              <h5 class="text-start mb-3 font-size-25">{{ 'account.edit.questions.title' | translate }}</h5>
              <fgbcl-edit-questions></fgbcl-edit-questions>
            </div>
          </ng-container>
        </ng-container>
        <div class="cach-back-container flex flex-column justify-content-center bg-white">
          <fgbcl-cash-back-toggle></fgbcl-cash-back-toggle>
          <p class="font-size-12 mb-0">{{ 'cash.back.description' | translate }}</p>
        </div>
      </ng-container>
    </div>
  </div>
</div>
